<template>
    <div class="gradeDetailCom">
            <p class="subject">
                {{data.gradeName}}-{{data.nameName}}
            </p>
            <p class="totalScore">总分：{{data.totalScore}}</p>
            <table class="gradeTable">
                <thead>
                <tr>
                    <th width='130'>科目</th>
                    <th width='100'>分数</th>
                    <th width='100'>年级人数</th>
                    <th width='100'>单科排名</th>
                    <th width='120'>年级总排名</th>
                    <th>考试说明</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value,index) in data.subject" :key="index" >
                    <td>{{value.subject}}</td>
                    <td>{{value.score}}</td>
                    <td>{{value.totalPeople}}</td>
                    <td>{{value.rank}}/{{value.totalPeople}}</td>
                    <td :rowspan="data.subject.length" v-if="index==0">{{data.totalRank}}/{{data.totalPeople}}</td>
                    <td><p :style="{display: 'flex',alignItems: 'center',lineHeight: '24px',justifyContent: 'center',padding: '0 10px'}">{{value.remark}}</p></td>
                </tr>
                </tbody>
            </table>
            <div class="summary">
                <p class="summaryTitle">
                    <span class="no1 block"></span>
                    <span class="no2 block"></span>
                    <span class="no3 block"></span>
                    <span class="name">考试总结</span>
                    <span class="no3 block"></span>
                    <span class="no2 block"></span>
                    <span class="no1 block"></span>
                </p>
                <el-input  type="textarea" v-model="data.remark" placeholder="请填写考试总结"  :rows="5"  :disabled="true"></el-input>
            </div>
            <div class="point">
                <p class="title">下一阶段重点提升学科</p>
                <p class="detail">
                    <span v-for="(value,index) in data.subject" :key="index" v-show="value.important==1">{{value.subject}}、</span>
                </p>
            </div>
        </div>
</template>
<script>
export default {
    name: "gradeAdd",
    props: ['data'],
    components: {
    },
    data() {
        return {
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            // "data": {
            //     "id": 40,
            //     "studentId": 1,
            //     "grade": 5,
            //     "name": 2,
            //     "totalScore": "638",
            //     "totalRank": 50,
            //     "totalPeople": 600,
            //     "remark": "1111111111111111111111",
            //     "subjects": "物理,化学,生物",
            //     "createdAt": "2021-01-21 11:01:12",
            //     "updatedAt": "2021-01-21 11:01:12",
            //     "deletedAt": null,
            //     "gradeName": "高三上学期",
            //     "nameName": "第二次月考",
            //     "subject": [{
            //         "subject": "语文",
            //         "score": "118",
            //         "rank": 20,
            //         "totalPeople": 600,
            //         "important": 0,
            //         "remark": "11111111"
            //     }, {
            //         "subject": "数学",
            //         "score": "120",
            //         "rank": 20,
            //         "totalPeople": 600,
            //         "important": 0,
            //         "remark": "11111111111"
            //     }, {
            //         "subject": "外语",
            //         "score": "120",
            //         "rank": 18,
            //         "totalPeople": 600,
            //         "important": 0,
            //         "remark": "11111111111111111111111"
            //     }, {
            //         "subject": "物理",
            //         "score": "90",
            //         "rank": 16,
            //         "totalPeople": 200,
            //         "important": 1,
            //         "remark": "1111111111111"
            //     }, {
            //         "subject": "化学",
            //         "score": "95",
            //         "rank": 20,
            //         "totalPeople": 200,
            //         "important": 1,
            //         "remark": "11111111111111111111111"
            //     }, {
            //         "subject": "生物",
            //         "score": "95",
            //         "rank": 18,
            //         "totalPeople": 200,
            //         "important": 1,
            //         "remark": "111111111111111"
            //     }],
            //     "actionSubject": [{
            //         "subject": "语文",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "118",
            //         "stageRankingGoal": "20"
            //     }, {
            //         "subject": "数学",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "122",
            //         "stageRankingGoal": "12"
            //     }, {
            //         "subject": "外语",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "130",
            //         "stageRankingGoal": "10"
            //     }, {
            //         "subject": "物理",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "90",
            //         "stageRankingGoal": "10"
            //     }, {
            //         "subject": "化学",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "95",
            //         "stageRankingGoal": "19"
            //     }, {
            //         "subject": "生物",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "90",
            //         "stageRankingGoal": "10"
            //     }, {
            //         "subject": "总分\/名次",
            //         "semesterTargetScore": null,
            //         "semesterRankingGoals": null,
            //         "stageScoreGoal": 645,
            //         "stageRankingGoal": 81
            //     }]
            // }
        }
    },
    created() {

    },
    methods: {

    },
}
</script>

<style scoped lang="less">
.gradeDetailCom {
        padding: 0 20px 30px 20px;
        background-color: #fff;

    .gradeTable {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
        input {
            border: none;
            line-height: 40px;
            text-align: center;
            padding-top: 0px;
            padding-bottom: 0px;
        }
        thead {
            background: rgba(61, 144, 246, 0.2);
            color: #333;
        }
        tr {
            border: 1px solid #C8E6F7;
        }
        td {
            border: 1px solid #C8E6F7;
            line-height: 40px;
        }
        td:first-child{
            background: #FAFDFF;
        }
        th {
            font-size: 16px;
            line-height: 40px;
            text-align: center;
        }
    }
    .summary {
        padding: 20px 0px;
        .area {
            font-size: 16px;
            line-height: 26px;
            min-height: 128px;
            background: rgba(61, 144, 246, 0.2);
            border-radius: 4px;
            border: none;
            padding: 15px;
        }
        .summaryTitle {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            height: 28px;
            font-weight: bold;
            margin-bottom: 20px;
            .name {
                padding: 0 3px;
            }
            .block {
                display: block;
                width: 8px;
                height: 8px;
                margin: 0 6px;
                border-radius: 4px;
            }
            .no1 {
                background: rgba(92, 92, 92, 0.3);
            }
            .no2 {
                background: rgba(92, 92, 92, 0.7);
            }
            .no3 {
                background: #5C5C5C;
            }
        }
    }
    .subject {
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        margin-bottom: 22px;
    }
    .totalScore {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 25px;
    }
    .point {
        padding-top: 15px;
        .title {
            height: 28px;
            font-size: 20px;
            line-height: 28px;
            margin-bottom: 12px;
            font-weight: bold;
        }
    }
}
</style>
<style lang="less">
.gradeDetailCom {
    .el-textarea.is-disabled .el-textarea__inner {
        background: rgba(61, 144, 246, 0.2);;
        color: #333;
        line-height: 26px;
        padding: 15px;
    }
}
</style>